var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuesEmpower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.033 31.67a.707.707 0 01-.497-.204.694.694 0 01-.206-.492v-4.416l-5.402-5.352a.907.907 0 00-1.245 0l-.136.136a.869.869 0 000 1.232l3.63 3.595a.694.694 0 01-.496 1.185.708.708 0 01-.496-.202l-3.63-3.596a2.257 2.257 0 010-3.203l.136-.135a2.273 2.273 0 011.616-.663 2.29 2.29 0 011.617.663l5.609 5.556a.696.696 0 01.205.492v4.704a.69.69 0 01-.205.495.705.705 0 01-.5.206z",
    fill: "url(#values_empower_svg__paint0_linear_3701_528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.707 31.67a.708.708 0 01-.498-.204.694.694 0 01-.206-.492v-.492L2.967 26.48a7.71 7.71 0 01-1.703-2.518 7.651 7.651 0 01-.592-2.973v-8.832c.001-.599.242-1.173.67-1.597a2.3 2.3 0 011.612-.663 2.3 2.3 0 011.615.662c.429.424.67.998.673 1.598v7.057a.693.693 0 01-.207.492.707.707 0 01-.994 0 .693.693 0 01-.207-.492v-7.057a.868.868 0 00-.257-.616.885.885 0 00-1.244 0 .869.869 0 00-.258.617v8.831a6.276 6.276 0 00.487 2.44 6.325 6.325 0 001.398 2.066l4.242 4.202c.131.13.206.307.206.491v.787a.695.695 0 01-.206.491.708.708 0 01-.495.206z",
    fill: "url(#values_empower_svg__paint1_linear_3701_528)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.797 31.67a.708.708 0 01-.497-.204.694.694 0 01-.206-.492V26.27a.69.69 0 01.206-.492l5.608-5.556a2.273 2.273 0 011.616-.663 2.289 2.289 0 011.617.663l.136.135a2.25 2.25 0 01.497 2.469 2.25 2.25 0 01-.497.734l-3.63 3.596a.71.71 0 01-.991 0 .696.696 0 010-.983l3.63-3.595a.865.865 0 00.251-.62.857.857 0 00-.258-.617l-.136-.135a.907.907 0 00-1.243 0l-5.408 5.352v4.416a.695.695 0 01-.203.49.708.708 0 01-.492.207z",
    fill: "url(#values_empower_svg__paint2_linear_3701_528)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.118 31.67a.707.707 0 01-.498-.204.694.694 0 01-.206-.492v-.787c0-.184.074-.36.205-.492l4.243-4.199a6.329 6.329 0 001.398-2.066 6.28 6.28 0 00.487-2.44v-8.832a.868.868 0 00-.257-.616.884.884 0 00-1.244 0 .868.868 0 00-.257.616v7.057a.694.694 0 01-.207.492.707.707 0 01-1.147-.226.691.691 0 01-.053-.267v-7.056c.001-.599.242-1.173.67-1.597a2.3 2.3 0 011.612-.664 2.3 2.3 0 011.612.665c.427.423.668.997.67 1.596v8.832a7.654 7.654 0 01-.59 2.972 7.711 7.711 0 01-1.7 2.517l-4.036 3.998v.491a.69.69 0 01-.204.496.704.704 0 01-.498.206z",
    fill: "url(#values_empower_svg__paint3_linear_3701_528)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.828 34.806a.707.707 0 01-.497-.204.694.694 0 01-.206-.493v-.87H7.617v.87a.69.69 0 01-.434.645.709.709 0 01-.919-.378.69.69 0 01-.053-.267v-1.572c0-.185.074-.362.206-.493a.707.707 0 01.497-.204h7.914c.187 0 .366.073.498.204.131.13.206.308.206.493v1.572a.694.694 0 01-.206.493.707.707 0 01-.498.204z",
    fill: "url(#values_empower_svg__paint4_linear_3701_528)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.914 34.806a.707.707 0 01-.497-.204.694.694 0 01-.206-.493v-.87h-6.508v.87a.69.69 0 01-.433.644.709.709 0 01-.92-.377.69.69 0 01-.053-.267v-1.572c0-.185.074-.363.206-.493A.707.707 0 0118 31.84h7.914c.187 0 .365.073.497.204.132.13.206.308.207.493v1.572a.69.69 0 01-.206.493.702.702 0 01-.498.204z",
    fill: "url(#values_empower_svg__paint5_linear_3701_528)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.435 8.714a4.014 4.014 0 01-2.82-1.16 3.94 3.94 0 01-1.17-2.794 3.94 3.94 0 011.17-2.794 4.015 4.015 0 012.82-1.16 4.015 4.015 0 012.82 1.16 3.94 3.94 0 011.17 2.794 3.94 3.94 0 01-1.17 2.794 4.014 4.014 0 01-2.82 1.16zm0-6.514a2.6 2.6 0 00-1.822.75 2.55 2.55 0 00-.758 1.806 2.55 2.55 0 00.758 1.805 2.6 2.6 0 001.822.751 2.6 2.6 0 001.823-.75 2.55 2.55 0 00.758-1.806 2.55 2.55 0 00-.757-1.806 2.6 2.6 0 00-1.824-.752V2.2z",
    fill: "url(#values_empower_svg__paint6_linear_3701_528)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.267 18.836c-5.173 0-7.145-2.26-8.092-3.342-.088-.098-.166-.19-.237-.268a.69.69 0 01-.188-.473V12.56a3.033 3.033 0 01.901-2.147 3.091 3.091 0 012.167-.892h11.178a3.091 3.091 0 012.168.892c.575.57.899 1.342.901 2.147v1.88c0 .166-.06.327-.169.453l-.166.197c-.938 1.123-3.134 3.747-8.463 3.747zm-7.106-4.35l.082.098c.874 1 2.5 2.86 7.03 2.86 4.663 0 6.499-2.19 7.379-3.244a.144.144 0 01.01-.014V12.56a1.64 1.64 0 00-.487-1.163 1.671 1.671 0 00-1.174-.482H10.818c-.44.002-.861.176-1.172.485a1.64 1.64 0 00-.485 1.162v1.925z",
    fill: "url(#values_empower_svg__paint7_linear_3701_528)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_empower_svg__paint0_linear_3701_528",
    x1: -8.126,
    y1: 25.603,
    x2: 32.31,
    y2: 26.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_empower_svg__paint1_linear_3701_528",
    x1: -7.653,
    y1: 20.765,
    x2: 32.279,
    y2: 22.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_empower_svg__paint2_linear_3701_528",
    x1: -8.593,
    y1: 25.605,
    x2: 32.313,
    y2: 26.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_empower_svg__paint3_linear_3701_528",
    x1: -9.066,
    y1: 20.354,
    x2: 36.035,
    y2: 21.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_empower_svg__paint4_linear_3701_528",
    x1: -8.595,
    y1: 33.321,
    x2: 31.846,
    y2: 33.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_empower_svg__paint5_linear_3701_528",
    x1: -10.47,
    y1: 33.321,
    x2: 33.733,
    y2: 33.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_empower_svg__paint6_linear_3701_528",
    x1: -9.058,
    y1: 4.754,
    x2: 31.851,
    y2: 5.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_empower_svg__paint7_linear_3701_528",
    x1: -8.595,
    y1: 14.171,
    x2: 32.317,
    y2: 14.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })))));
}
export default __webpack_public_path__ + "static/values_empower.d1fa55b3.svg";
export { SvgValuesEmpower as ReactComponent };